import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';
import { ensureCurrentUser } from '../../util/data';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl, currentUser, scrambleWords } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }
  const user = ensureCurrentUser(currentUser);

  const isUserPremium = user && user?.attributes?.profile?.metadata?.isPremium
  const isSellListing = publicData.listingType === 'sell';

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const currencyMapper = {
    "britishpound": "GBP",
    "Dollar": "USD",
  }
  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);
  const shouldBlurDetails = false// !isUserPremium && isSellListing;

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      {/* <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading> */}
      <ul className={css.details}>
        {existingListingFields
          .sort(f => {
            if (f.key == 'asking_price') {
              return 1
            } else if (f.key == 'Budget_Maximum') {
              return -1
            } else {
              return 0;
            };
          })
          .filter(f => !f.key.endsWith("Filter"))
          .map(detail => (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>{detail.label}:</span>
              <span className={`${shouldBlurDetails ? css.blurredValue : ''} ${css.detailContent}`}>
                {shouldBlurDetails ? scrambleWords(detail.value.toLocaleString()) : detail.value.toLocaleString()} {["Budget_minimum", "Budget_Maximum", "asking_price"].includes(detail.key) && publicData.currency
                  ? publicData.currency
                  : currencyMapper[publicData.Currency] ? currencyMapper[publicData.Currency] : publicData.Currency}
              </span>
            </li>
          ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
